import Link from 'next/link';
import React from 'react';
import { Dimmer, Header } from 'semantic-ui-react';

export default ({ children, dimmed }) => (
  <Dimmer.Dimmable
    style={{ display: 'block', height: dimmed ? '4em' : '100%', zIndex: 0 }}
    dimmed={dimmed}
    blurring
  >
    {children}
    <Dimmer active={dimmed}>
      <Link href="/login">
        <Header as="h3" inverted>
          登入後觀看
        </Header>
      </Link>
    </Dimmer>
  </Dimmer.Dimmable>
);
